import axios from 'axios';

axios.defaults.timeout = 10000;

if (process.env.VUE_APP_NODE_ENV === 'alpha') {
  axios.defaults.baseURL = location.protocol.indexOf('https:') > -1 ? process.env.VUE_APP_HTTPS_BASE_URL : process.env.VUE_APP_HTTP_BASE_URL;
} else {
  axios.defaults.baseURL = process.env.VUE_APP_BASE_URL;
}

axios.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    return Promise.reject(error.response);
  }
);

axios.interceptors.response.use(
  (response) => {
    /**
     * - TODO: ErrorMsg 처리
     */
    // window.$mitt.emit('DialogPopup', {
    //   useDialog: true,
    //   message: 'ErrorMsg'
    // })
    return response;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default axios;
